import { BigQueryEventTypes } from '../types';
import { createBaseUserActionEvent } from './base';

const { clickedOnTranslationButton, clickedOnCancelledTranslationButton } = BigQueryEventTypes.translation;

export const UserActionsBigQueryEvents = {
    clickedOnTranslationButton: (params) => createBaseUserActionEvent(clickedOnTranslationButton, params),
    clickedOnCancelledTranslationButton: (params) =>
        createBaseUserActionEvent(clickedOnCancelledTranslationButton, params),
};
